// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"360":"b126a583428247cc","888":"7ba75bfb699cae04","975":"b126a583428247cc"}[chunkId] + ".css";
};